export const SECURITY_COOKIE_NAME = 'sc_security'
export const SECURITY_COOKIE_VALIDITY = '1d' // TODO Decide how long
export const LOGIN_COOKIE_NAME = 'userLoggedIn'
export const SECURITY_MODAL_TIMEOUT = 10 * 60 * 1000 // treba da bude 10 minuta u ms -> 10 * 60 * 1000
